import requests from "./httpService";

const AirportPickupPeriodicHikeTimeServices = {
  getAllAirportPickupPeriodicHikeTime: async (body) => {
    return requests.get(`/airportPickupPeriodicHikeTime/`);
  },

  addAirportPickupPeriodicHikeTime: async (body) => {
    return requests.post(`/airportPickupPeriodicHikeTime/add`, body);
  },
  getAirportPickupPeriodicHikeTimeById: async (id) => {

    return requests.get(`/airportPickupPeriodicHikeTime/${id}`);
  },

  updateAirportPickupPeriodicHikeTime: async (id, body) => {
    return requests.put(`/airportPickupPeriodicHikeTime/update/${id}`, body);
  },

  deleteAirportPickupPeriodicHikeTime: async (id) => {
    return requests.delete(`/airportPickupPeriodicHikeTime/delete/${id}`);
  },
};

export default AirportPickupPeriodicHikeTimeServices;
